import { render } from "./MemberPay.vue?vue&type=template&id=2ca4bab6"
import script from "./MemberPay.vue?vue&type=script&lang=js"
export * from "./MemberPay.vue?vue&type=script&lang=js"

import "./MemberPay.vue?vue&type=style&index=0&id=2ca4bab6&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__